import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  getExperimentPayload,
  getExperimentVariant,
} from '../../shared/utilities/amplitudeExperiment';

export const selectExperimentsReady = (state) => state.experiments?.isReady ?? false;

const useExperiment = (experimentId) => {
  const isReady = useSelector(selectExperimentsReady);

  const payload = useMemo(() => getExperimentPayload(experimentId), [experimentId, isReady]);
  const variant = useMemo(() => getExperimentVariant(experimentId), [experimentId, isReady]);

  return {
    isReady,
    payload,
    variant,
  };
};

export default useExperiment;